<template>
  <div class="cash-flow-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Financeiro &raquo; Fluxo de Caixa</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col>
            <label class="cj-label">Período</label>
            <date-range-picker
              class="w-100"
              ref="picker"
              :localeData="dateRangePickerPtBrLocale"
              :timePicker="false"
              :timePicker24Hour="false"
              :showDropdowns="true"
              :ranges="false"
              :showWeekNumbers="false"
              :opens="'right'"
              v-model="cashflowFilterForm.dateTime">
              <div slot="input" slot-scope="picker" class="">
                {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}
              </div>
            </date-range-picker>
          </b-col>
          <b-col>
            <label class="cj-label">Conta</label>
            <multiselect v-model="cashflowFilterForm.bank_account" :options="bank_accounts" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
              <template slot="clear">
                <div class="multiselect__clear" v-if="cashflowFilterForm.bank_account != null" @mousedown.prevent.stop="cashflowFilterForm.bank_account = null"></div>
              </template>

            </multiselect>
          </b-col>
          <b-col>
            <label class="cj-label">Profissional</label>
            <multiselect v-model="cashflowFilterForm.professional" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
              <template slot="clear">
                <div class="multiselect__clear" v-if="cashflowFilterForm.professional != null" @mousedown.prevent.stop="cashflowFilterForm.professional = null"></div>
              </template>
            </multiselect>
          </b-col>
          <b-col>
            <label class="cj-label w-100">&nbsp;</label>
            <b-button variant="primary" block @click="getCashflow()"><i class="far fa-search"></i> Filtrar</b-button>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="12" class="text-right">
            <b-button size="sm" variant="primary" @click="exportItems()"><i class="far fa-download"></i> Exportar lançamentos</b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table text-center">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Entrada</th>
                      <th>Saída</th>
                      <th>Saldo</th>
                      <th>Comissão</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(cashFlow, date) in cashFlows">
                      <tr class="month-entry" :key="date">
                        <td>{{ moment(date + '-01').format('MMMM YYYY') }}</td>
                        <td>{{ formatPrice(cashFlow.income) }}</td>
                        <td>{{ formatPrice(cashFlow.expense) }}</td>
                        <td class="text-light-force" :class="(cashFlow.balance > 0)?'bg-success':'bg-danger'">{{ formatPrice(cashFlow.balance) }}</td>
                        <td>{{ formatPrice(cashFlow.commission) }}</td>
                      </tr>
                      <tr class="date-entry" v-for="entry in cashFlow.entries" :key="entry.id">
                        <td>{{ entry.date }}</td>
                        <td>{{ formatPrice(entry.income) }}</td>
                        <td>{{ formatPrice(entry.expense) }}</td>
                        <td :class="(entry.balance > 0)?'text-success':'text-danger'">{{ formatPrice(entry.balance) }}</td>
                        <td>{{ formatPrice(entry.commission) }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        canSee: true,
        canManage: true,

        cashflowFilterForm: {
          dateTime: { startDate: this.moment().startOf('month'), endDate: this.moment().endOf('month') },
          bank_account: null,
          professional: null
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        },

        bank_accounts: [],
        professionals: [{value: 'none', name: 'Nenhum'}, {value: 'all', name: 'Todos profissionais'}],

        cashFlows: []
      }
    },
    async mounted () {
      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('cash-flow', 'can_see');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission('cash-flow', 'can_manage');

      if(this.canSee == false || this.canManage == false || !this.helpers.planHasPermission('financial')) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' });
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      await this.api.getPeople({type: 'PROFESSIONAL'}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.professionals = [{value: 'none', name: 'Nenhum'}, {value: 'all', name: 'Todos profissionais'}];
        res.data.data.forEach(professional => {
          this.professionals.push({value: professional.id, name: professional.name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Professional', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os profissionais da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Professional', err.response);
      });

      await this.api.getBankAccounts().then(res => {
        if(this.leavingPage) {
          return;
        }
        this.bank_accounts = [];
        res.data.forEach(category => {
          this.bank_accounts.push({value: category.id, name: category.name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Bank Accounts', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as contas bancárias! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Bank Accounts', err.response);
      });

      await this.getCashflow();
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      getCashflow() {
        let cashFlowFilterData = {
          start_date: this.moment(this.cashflowFilterForm.dateTime.startDate).format('YYYY-MM-DD'),
          end_date: this.moment(this.cashflowFilterForm.dateTime.endDate).format('YYYY-MM-DD'),
          bank_account: (this.cashflowFilterForm.bank_account != null)?this.cashflowFilterForm.bank_account.value:null,
          professional: (this.cashflowFilterForm.professional != null)?this.cashflowFilterForm.professional.value:null
        };

        this.api.getCashflow(cashFlowFilterData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }

          this.cashFlows = res.data;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Cashflow', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }

          this.$swal('Ops...', 'Não conseguimos carregar o seu fluxo de caixa! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Cashflow', err.response);
        });
      },

      formatPrice(value) {
        let prefix = (value < 0)?'- R$ ':'R$ ';
        let val = Math.abs((value/1)).toFixed(2).replace('.', ',')
        return prefix+val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      exportItems() {
        this.eventBus.$emit('IS_LOADING', true);
        let cashFlowFilterData = {
          start_date: this.moment(this.cashflowFilterForm.dateTime.startDate).format('YYYY-MM-DD'),
          end_date: this.moment(this.cashflowFilterForm.dateTime.endDate).format('YYYY-MM-DD'),
          bank_account: (this.cashflowFilterForm.bank_account != null)?this.cashflowFilterForm.bank_account.value:null,
          professional: (this.cashflowFilterForm.professional != null)?this.cashflowFilterForm.professional.value:null
        };
        this.api.exportCashflowData(cashFlowFilterData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }

          var type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              blob = new Blob([res.data], { type: type }),
              anchor = document.createElement('a');

          anchor.download = 'fluxo-de-caixa.xlsx';
          anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
          anchor.dataset.downloadurl = [type, anchor.download, anchor.href].join(':');
          anchor.click();

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Export Cashflow Data', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos exportar o fluxo de caixa da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Export Cashflow Data', err.response);
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .cash-flow-list {
    padding: 20px 0;

    .text-light-force, .text-light-force * {
      color: $whisper !important;
    }

    .table {
      .month-entry {
        background-color: #eee!important;

        .bg-success {
          border-top-color: #28a745;
        }
        .bg-danger {
          border-top-color: #dc3545;
        }
      }
      .date-entry {
        background-color: #fff!important;
        font-family: 'sf_pro_displayregular';

        .text-success,
        .text-danger {
          font-family: 'sf_pro_displaysemibold';
        }
      }
    }
  }
</style>
